import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { adminAuthInterceptor } from './core/auth/admin-auth.interceptor';
import { environment } from '../environments/environment';

/**
 * Custom Aura theme — only overrides the accent colour while keeping
 * light-mode surface/background tokens untouched so tables stay white.
 */
const CustomAura = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        accent: {
          color: 'hsl(19.88, 100%, 68.04%)',
          contrastColor: 'hsl(0, 0%, 20%)',
          hoverColor: 'hsl(19.88, 90%, 60%)',
          activeColor: 'hsl(19.88, 85%, 52%)',
        },
      },
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    providePrimeNG({
      theme: {
        preset: CustomAura,
        options: {
          darkModeSelector: false, // forces light mode regardless of OS preference
        },
      },
    }),
    provideFirebaseApp(() =>
      initializeApp(environment.firebase)
    ),
    provideAuth(() => getAuth()),
    provideHttpClient(withInterceptors([adminAuthInterceptor])),
  ],
};
